import React from 'react';
import { useIntl } from 'react-intl';
import TrimmedMarkdownRender from '@/components/text-editors/TrimmedMarkdownRender';
import Error from '@/components/errors/Error';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';

const RequestMarkdownFallback = ({ category, code }) => {
  const intl = useIntl();
  const { readStatus, text } = Selectors.useRequestMarkdownPanelAll({ category, code });
  Fetch.useFetchRequestMarkdown({ category, code }, readStatus);

  return (
    <>
      <Error
        warning
        title={intl.formatMessage({ id: 'request.source.not.found.header' })}
        error={intl.formatMessage({ id: 'request.source.not.found.message' })}
      />
      <TrimmedMarkdownRender text={text} withMessage />
    </>
  );
};

export default RequestMarkdownFallback;
